<template>
	<div class="room-page">
		<!-- <div @click="testClick" style="position: absolute; z-index: 10000; right: 0px; font-size: 25px; align-items: center; justify-content: center; display: flex;">开始屏息</div> -->
		<div class="room-left-con">
			<div class="top" v-if="detailPageData.status !== 3 && detailPageData.status !== 4">
				<div v-if="(detailPageData.subStatus == 1 && detailPageData.status == 1) ||
					(detailPageData.subStatus == 1 &&
						(detailPageData.status == 5 || detailPageData.status == 6))
					">
					<img class="alarm-icon" src="./../../assets/img/Avatar@2x.png" alt="" />
				</div>
				<div v-else>
					<div v-if="detailPageData.statusName == '睡觉'">
						<img class="alarm-icon" src="./../../assets/img/AvatarSleep@2x.png" alt="" />
					</div>
					<div v-else>
						<img class="alarm-icon" v-if="stableNum >= 80" src="./../../assets/img/Avatar_people@2x.png" alt="" />
						<img class="alarm-icon" v-if="stableNum < 80 && stableNum >= 59" src="./../../assets/img/MediumMove-80.gif"
							alt="" />
						<img class="alarm-icon" v-if="stableNum < 59" src="./../../assets/img/FastMove-80.gif" alt="" />
					</div>
				</div>
				<div class="status">
					<div class="status-top">
						<div class="text" :class="{
							'text-alarm':
								detailPageData.statusName == '心跳过速' ||
								detailPageData.statusName == '心跳过缓' ||
								detailPageData.statusName == '呼吸过缓' ||
								detailPageData.statusName == '呼吸过速' ||
								(detailPageData.statusName == '疑似生命体征微弱' && detailPageData.status != 1) ||
								detailPageData.statusName == '离床过久',
						}">
							{{ detailPageData.statusName }}
						</div>
						<div class="bar" v-if="monitorStatusStr == ''">
							数据载入中 {{ num }}s
						</div>
						<div class="bar" v-else>{{ monitorStatusStr }}</div>
					</div>
					<div class="stable" v-if="(detailPageData.subStatus !== 1 && detailPageData.status !== 1) ||
						(detailPageData.subStatus !== 1 &&
							(detailPageData.status !== 5 || detailPageData.status !== 6))
						">
						<div class="stable-alarm" :style="{
							width: stableNum < 20 ? 20 + '%' : stableNum + '%',
							background:
								'linear-gradient(270deg,' +
								endColor +
								' 0%,' +
								beginColor +
								' 100%)',
						}">
							{{ stableNum }}% 稳定
						</div>
					</div>
				</div>
			</div>
			<div class="room-left" v-show="!showEchars">
				<!-- 离床报警 -->
				<img class="alarm-icon" v-if="detailPageData.subStatus == 1 && detailPageData.hasAlarm == true
					" src="./../../assets/img/warning-circle-fill@2x.png" alt="" />
				<span class="leave-bed-alarm" v-if="detailPageData.subStatus == 1 &&
					detailPageData.hasAlarm == true &&
					duration != ''
					">{{ detailPageData.statusName }} {{ duration }}</span>
				<!-- 离床不报警 -->
				<span class="leave-bed-noalarm" v-if="detailPageData.subStatus == 1 &&
					detailPageData.status == 1 &&
					detailPageData.hasAlarm == false &&
					duration != ''
					">{{ detailPageData.statusName }} {{ duration }}</span>
				<span class="off-line" v-if="detailPageData.status == 3">离线</span>
				<span class="close" v-if="detailPageData.status == 4">监测仪已关闭</span>
			</div>
			<div class="echats-con" v-show="showEchars">
				<div ref="RefChart1" class="grid_line" style="width: 880px;height:145px;"></div>
				<!-- <div ref="RefChart1" class="grid_line" style="width: 880px;height:145px; position: absolute; background: green; opacity: 0.3;"></div> -->
				<div class="split-line"></div>
				<div class="heart-con">
					<div ref="RefChart2" class="grid_line" style="width: 880px;height:160px;"></div>
					<!-- <div ref="RefChart2" class="grid_line" style="width: 880px;height:160px; position: absolute; background: green; opacity: 0.3;"></div> -->
					<!-- <div v-if="showEchars" class="heart-circle" :style="{
						left: circlePosition,
						top: circleTopPosition,
						background: circleBackground,
					}"></div> -->
				</div>
			</div>
		</div>
		<div class="room-right">
			<div v-if="isShowGray === 1" class="room-right-con">
				<div class="switch">
					<div class="realTop_left">
						<div class="left_header">
							<span class="left_title">监测仪</span>
							<div style="position: relative; top:-2px" v-if="role == 3">
								<el-switch v-model="switchStatus" :width="40" class="switch" active-color="#1890FF"
									inactive-color="#79b5f6" @change="setStatus">
								</el-switch>
								<span v-if="switchStatus" style="top:5px" class="switch-btn-open">开</span>
								<span v-else style="top:5px" class="switch-btn-off">关</span>
							</div>
							<div style="position: relative;" v-else class="left_title title-flex">
								<el-switch v-model="switchStatus" :width="40" class="switch" active-color="#1890FF"
									inactive-color="#79b5f6" @change="setStatus">
								</el-switch>
								<span v-if="switchStatus" class="switch-btn-open">开</span>
								<span v-else class="switch-btn-off">关</span>
								<div class="title-flex-set" @click="setToitet">设置</div>
							</div>
						</div>
					</div>
				</div>
				<div class="room-icon">
					<div class="img_icon">
						<img src="./../../assets/img/breath_gary.png" alt="" />
						<div>--</div>
					</div>
					<div class="img_icon">
						<img src="./../../assets/img/heart_gary.png" alt="" />
						<div>--</div>
					</div>
				</div>
			</div>
			<div v-if="isShowGray === 2" class="room-right-con">
				<div class="switch">
					<div class="realTop_left">
						<div class="left_header">
							<span class="left_title">监测仪</span>
							<div style="position: relative;" v-if="role == 3">
								<el-switch v-model="switchStatus" :width="40" class="switch" active-color="#1890FF"
									inactive-color="#79b5f6" @change="setStatus">
								</el-switch>
								<span v-if="switchStatus" class="switch-btn-open">开</span>
								<span v-else class="switch-btn-off">关</span>
							</div>
							<div style="position: relative;" v-else class="left_title title-flex">
								<el-switch v-model="switchStatus" :width="40" class="switch" active-color="#1890FF"
									inactive-color="#79b5f6" @change="setStatus">
								</el-switch>
								<span v-if="switchStatus" class="switch-btn-open">开</span>
								<span v-else class="switch-btn-off">关</span>
								<div class="title-flex-set" @click="setToitet">设置</div>
							</div>
						</div>
					</div>
				</div>
				<div class="room-icon">
					<div class="room-icon-item">
						<div class="item-text item-lin" v-if="roomStatus == 1 || roomStatus == 5 || roomStatus == 6">
							<p class="conter-low" :class="{ 'alarm-conter': isShowRedBreath == 1 }"></p>
							<p class="conter"></p>
							<p class="conter-height" :class="{ 'alarm-conter': isShowRedBreath == 3 }"></p>
							<div class="position-cirle" :class="{ 'alarm-conter': isShowRedBreath !== 2 }" :style="{
								left: breathPosition,
								background: isShowRedBreath !== 2 ? '#FF4D4F' : '#5CC726',
							}"></div>
						</div>
						<div class="item-text" v-if="roomStatus == 1 || roomStatus == 5 || roomStatus == 6">
							<p :class="{ 'alarm-conter': isShowRedBreath == 1 }">偏低</p>
							<p :style="{
								color: isShowRedBreath == 2 ? '#5CC726' : '#262626',
							}">
								正常
							</p>
							<p :class="{ 'alarm-conter': isShowRedBreath == 3 }">偏高</p>
						</div>
						<div class="img_icon">
							<img v-if="isShowRedBreath == 2" src="./../../assets/img/breath_blue.png" alt="" />
							<img v-else src="./../../assets/img/breath_alarm@2x.png" alt="" />
							<div class="breath-text" :style="{ color: isShowRedBreath !== 2 ? '#FF4D4F' : '' }">
								{{ breathBpm }}
							</div>
						</div>
					</div>
					<div class="room-icon-item">
						<div class="item-text item-lin" v-if="roomStatus == 1 || roomStatus == 5 || roomStatus == 6">
							<p class="conter-low" :class="{ 'alarm-conter': isShowRedHeart == 1 }"></p>
							<p class="conter"></p>
							<p class="conter-height" :class="{ 'alarm-conter': isShowRedHeart == 3 }"></p>
							<div class="position-cirle" :class="{ 'alarm-conter': isShowRedHeart !== 2 }" :style="{
								left: heartPosition,
								background: isShowRedHeart !== 2 ? '#FF4D4F' : '#5CC726',
							}"></div>
						</div>
						<div class="item-text" v-if="roomStatus == 1 || roomStatus == 5 || roomStatus == 6">
							<p :class="{ 'alarm-conter': isShowRedHeart == 1 }">偏低</p>
							<p :style="{
								color: isShowRedHeart == 2 ? '#5CC726' : '#262626',
							}">
								正常
							</p>
							<p :class="{ 'alarm-conter': isShowRedHeart == 3 }">偏高</p>
						</div>
						<div class="img_icon">
							<img v-if="isShowRedHeart == 2" src="./../../assets/img/heart_green.png" alt="" />
							<img v-else src="./../../assets/img/heart_alarm@2x.png" alt="" />
							<div class="heart-text" :style="{ color: isShowRedHeart !== 2 ? '#FF4D4F' : '' }">
								{{ heartBpm }}
							</div>
						</div>
					</div>
				</div>
			</div>
			<a-modal title="设置" :width="632" :visible="editAbnormalTimePopupOutBed" :maskClosable="false" :footer="null"
				@cancel="editAbnormalTimeCancelOutBed">
				<div style="display: flex;">
					<div v-if="getFallLongTimeData.timePeriods && getFallLongTimeData.timePeriods.length > 0">
						<div class="titleTime mb10">监测时间段</div>
						<div class="picker" :key="index" v-for="(item, index) in getFallLongTimeData.timePeriods">
							<a-time-picker :allowClear="false" v-model="item.startTime" format="HH:mm"></a-time-picker>
							<img class="rJt" src="../../assets/rJt.png" alt="">
							<a-time-picker :allowClear="false" v-model="item.endTime" format="HH:mm"></a-time-picker>
						</div>
					</div>
					<div class="picker" style="margin-left: 20px;">
						<div class="titleTime">离床异常时长</div>
						<div style="display: flex; align-items: center; margin-top: 10px;" v-for="(item, index) in getFallLongTimeData.timePeriods">
							<div style="position: relative; margin-right: 10px;">
								<el-switch v-model="item.outBedEnable == 0 ? true : false" :width="40" class="switch" active-color="#1890FF"
									inactive-color="rgba(191, 191, 191, 1)" @change="swictchChangeLeaveBedTime(item, index)">
								</el-switch>
								<span v-if="item.outBedEnable == 0 ? true : false" class="switch-btn-open" style="position: absolute; left: 7px; color: #FFFFFF; font-size: 12px; top: 3px;">开</span>
								<span v-else class="switch-btn-off" style="position: absolute; right: 7px; color: #FFFFFF; font-size: 12px; top: 3px">关</span>
							</div>
							<!-- 删除了 :disabled="OutBeddisabled" -->
							<a-time-picker :allowClear="false" v-model="item.editHandleTimeValOutBed" format="HH:mm:ss" :style="{opacity: item.outBedEnable == 0 ? 1 : 0.3}" :disabled="item.outBedEnable == 0 ? false : true"></a-time-picker>
						</div>
					</div>
					<div class="leave_phone_alarm">
						<div class="titleTime mb10">离床电话报警</div>
						<div class="leave_phone_alarm-content" :key="index" v-for="(item, index) in getFallLongTimeData.timePeriods">
							<el-switch v-model="item.outBedPhoneEnable == 0 ? true : false" :width="40" class="switch" active-color="#1890FF" inactive-color="rgba(191, 191, 191, 1)" @change="swictchChangeLeaveBedPhone(item, index)"></el-switch>
							<span v-if="item.outBedPhoneEnable == 0 ? true : false" class="switch-btn-open" style="position: absolute; left: 7px; color: #FFFFFF; font-size: 12px; top: 7px;">开</span>
							<span v-else class="switch-btn-off" style="position: absolute; right: 51px; color: #FFFFFF; font-size: 12px; top: 7px">关</span>
						</div>
					</div>
				</div>
				<div style="display: flex; align-items: center; margin-top: 10px; margin-bottom: 20px;">
					<div style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: #58595A; line-height: 20px;">呼吸过速报警阈值</div>
					<!-- <a-dropdown :trigger="['click']">
						<a-menu slot="overlay">
							<a-menu-item @click="changeTempBpm(subItem)" :key="subIndex" v-for="(subItem, subIndex) in [27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40]" :style="{ background: subItem == tempBreathBpm ? 'rgba(245, 247, 250, 1)' : '', color: subItem == tempBreathBpm ? 'rgba(24, 144, 255, 1)' : ''}">
								{{ subItem }}
							</a-menu-item>
						</a-menu>
						<a-button style="margin-left: 10px; margin-right: 10px; width: 100px; text-align: left; width: 88px;">{{ tempBreathBpm }}<a-icon type="down" /> </a-button>
					</a-dropdown> -->
					<a-select
						v-if="alarmModel"
						placeholder="请选择"
						:default-value="alarmModel.breathFast"
						option-filter-prop="children"
						style="width: 99px; margin-left: 10px; margin-right: 10px;"
						:filter-option="filterOption"
						@focus="handleFocus"
						@blur="handleBlur"
						@change="handleChange"
					>
						<a-select-option :value="item" :key="index" v-for="(item, index) in [27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40]">
						{{ item }}
						</a-select-option>
					</a-select>
					<div style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: #58595A; line-height: 20px;">bpm</div>
				</div>
				<div class="picker">
					<div class="titleTime">关联卫生间</div>
					<a-cascader :value="relateWC_treeData_value_Sel_Next" :default-value="relateWC_treeData_value"
						:options="relateWC_treeData" placeholder="点击选择需要关联的设备" @change="change_relateWC($event)" />
				</div>
				<div class="addBtn toitet-btn">
					<a-button style="margin-right: 10px" @click="editAbnormalTimeCancelOutBed">取消</a-button>
					<a-button type="primary" @click="editAbnormalTimeToitetNewNew">确定</a-button>
				</div>
			</a-modal>
			<a-modal title="温馨提示" :width="400" :visible="isShowTipAlertWqsn" :maskClosable="false" :footer="null"
				@cancel="tipAlertClickCancelWqsn">
				<div style="display: block; align-items: center; margin-top: 10px; margin-bottom: 20px;">
					<img style="width: 16px; height: 16px; display: inline; margin-right: 5px; margin-top: -2px;" src="./../../assets/icon_alert_warning.png" alt="" />
					<div style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: #58595A; line-height: 20px; display: inline;">当前建议的阈值是最适合“完全失能”老人的设置，修改之后可能会影响监测效果，请慎重考虑，确定要修改吗？</div>
				</div>
				<div class="addBtn toitet-btn" style="margin-left: 210px;">
					<a-button style="margin-right: 10px" @click="tipAlertClickCancelWqsn">取消</a-button>
					<a-button type="primary" @click="tipAlertClickSureWqsn">确定</a-button>
				</div>
			</a-modal>
		</div>
	</div>
</template>
<script>
import Stomp from 'stompjs';
import SockJS from 'sockjs-client';

import detaliPageConRoomCommonData1 from './detaliPageConRoomCommonData1.json'
import detaliPageConRoomCommonData2 from './detaliPageConRoomCommonData2.json'
import detaliPageConRoomCommonData3 from './detaliPageConRoomCommonData3.json'
import detaliPageConRoomCommonData4 from './detaliPageConRoomCommonData4.json'

import getEchartOptionDetaliPageConRoom1 from '../detaliPage/detaliPageConRoom1.js'
import getEchartOptionDetaliPageConRoom2 from '../detaliPage/detaliPageConRoom2.js'

import { get_alarm_detail_breathe_chart_option } from './AlarmDetailBreatheChartOption.ts'
import { get_alarm_detail_heart_chart_option } from './AlarmDetailHeartChartOption.ts'

export default {
	props: {
		detailPageData: {
			type: Object,
			default: () => { },
		},
		pageBottomData: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {
			// 监测时段相关
			getFallLongTimeData: '',
			OutBeddisabled: false,
			isOutBed: 0,
			role: 2,
			heartBPM: '--',
			breathBPM: '--',
			switchStatus: true,
			isShowGray: 2,
			duration: '',
			socketStatus: null,
			stompClientStatus: null,
			reconInv: null,
			breathXdata: [],
			breathYdata: [],
			breathYdataCopy: [],
			breathInterval: null,
			heartXdata: [],
			heartYdata: [],
			heartYdataCopy: [],
			heartInterval: null,
			replaceArr: [],
			circlePosition: '0%',
			circleTopPosition: '0px',
			circleBackground: '#53c31b',
			breathPosition: '0%',
			heartPosition: '0%',
			isShowRedHeart: 2,
			isShowRedBreath: 2,
			roomStatus: 1,
			isShowEchars: false,
			num: 10,
			intervalPulsSecond: null,
			secondNum: 0,
			stableNum: 100,
			monitorStatusStr: '',
			beginColor: '#DA9D0B',
			endColor: '#65E332',
			socketStatusEchars: null,
			stompClientStatusEchars: null,
			reconInvEcahrs: null,
			showEchars: false,
			leaveBedInterval: null,
			heartflag: 0,

			// 模拟呼吸波形
			Buff_BreathWave_Y_Flt: [0, 0, 0, 0, 0],
			Phi: 0,
			BreathWave_A: 5,
			// 模拟心跳波形
			Buff_Electrocardiogram_QRST: detaliPageConRoomCommonData2, // 100Hz QRST波模型
			Buff_Electrocardiogram_PR: detaliPageConRoomCommonData3, // 100Hz PR波模型
			HeartWave_QRSTPR_cnt: 66, // QRSTPR波对应的时间（毫秒）
			T_cnt_present: -1, // 当前正在绘制的图形的周期点数
			pointer: 0, // 当前从心跳模型中打点的位置
			HeartWave_Y_Mode: [0], // 心跳波形模型初始化
			Counter: 5,
			CounterInterval: null,
			drawInterval: null,
			myChartHeart: null,
			myChartBreath: null,
			changeHeartDataInterval: null,
			heartAllLineData: [],
			isBeginDrawechars: false,
			bedSetId: '', // 离床报警设置设备id
			radarId: '', // 离床报警设置设备id
			editHandleTimeValOutBed: '', // 离床时长异常时间值
			editAbnormalTimePopupOutBed: false,
			// 关联卫生间树形结构部分
			relateWC_treeData: [],
			relateWC_treeData_value: [], //当前值,为进入查看时的值
			relateWC_treeData_value_Sel_Prev: [], //选中前的值
			relateWC_treeData_value_Sel_Next: [], //选中后的值



			// 画线 Websocket
			stompClient: null,
			socket: null,
			timer: null,
			start1: null,

			// 状态 Websocket
			statusStompClient: null,
			statusSocket: null,
			statusTimer: null,
			start2: null,

			// 定时器 - 创造数据
			createDataInterval: null,
			createDataIntervalCount: 0,

			// 定时器 - 离床时长
			durationTimer: null,

			// WebSocket 传输过来的数据
			websocketData: null,

			/**
				 * WebSocket相关内容
				 */
			// 呼吸率 & 心率 相关
			sockFlagNum: 0,
			// 呼吸率相关
			breathBpm: '--',
			breathDatas: [],
			paintBreathDatas: [],
			paintBreathDatasCurrentIndex: 0,
			Phi: 0,
			Buff_BreathWave_Y_Flt: [0, 0, 0, 0, 0],
			// 心率相关
			heartBpm: '--',
			heartDatas: [],
			paintHeartDatas: [],
			paintHeartDatasCurrentIndex: 0,
			pointer: 0,
			HeartWave_Y_Mode: [0],
			T_cnt_present: 0,

			// 图表
			chart1: null,
			chart2: null,
			
			
			showImageName1: '',
			showImageName2: '',
			showImageName3: '',
			showImageName4: '',
			showImageName5: '',
			showText: '',
			showTextColor: '',
			statusName: '',
			stableNum: '',
			isShowStableNum: false,
			breatheColor: '#1890ff',
			breatheImageName: 'icon_alarm_detail_state_6.png',
			showBreatheBpm: '-',
			heartColor: '#53c31b',
			heartImageName: 'icon_alarm_detail_state_1.png',
			showHeartBpm: '-',
			progressArr: [],
			maxWidth: 500,

			tempSwitchState: true,

			alarmModel: null,

			isShowTipAlertWqsn: false,
			compareOldTimePeriods: null
			
		};
	},
	created() {


		// 白天：呼吸 12-20 心跳：55-100
		// 黑夜：呼吸 8-24  心跳：40-90

		// 1.模拟呼吸400个点位
		for (let i = 0; i < 400; i++) {
			this.breathYdataCopy.push(0);
		}

		// 2.获取用户信息
		this.role = this.$getCookie('userInfo').user.roleId;

		// 3.控制右侧监测仪是否为灰色
		if (this.detailPageData.status == 3 || this.detailPageData.status == 4) {
			this.isShowGray = 1;
		} else if (
			this.detailPageData.status == 1 ||
			this.detailPageData.subStatus == 1
		) {
			this.isShowGray = 2;
		}

		// 4.初始化已离床时间
		this.duration = '';

		// 5.模拟心率600个点位
		for (let i = 0; i < 600; i++) {
			this.heartXdata.push(0);
			this.heartYdataCopy.push(0);
		}

		// 6.模拟呼吸400个点位
		for (let i = 0; i < 400; i++) {
			this.breathXdata.push(0);
		}

		// 7.心率替换数组 - 固定 - 20个空字符串
		for (let i = 0; i < 20; i++) {
			this.replaceArr.push('');
		}

		// 8.判断是否已离床
		if (
			(this.detailPageData.status == 5 || this.detailPageData.status == 6) &&
			this.detailPageData.subStatus == 1
		) {
			// this.monitorStatusStr = '已离床';
			this.monitorStatusStr = this.detailPageData.statusName;
		}

		// 9.初始化是否显示图表
		this.showEchars = this.detailPageData.showEchars;

		// 10.获取床位信息
		// this.getBedInfoById(this.detailPageData.bedId);
	},
	mounted() {
		let that = this;

		// 3.倒计时 10s
		let interval = null;
		interval = setInterval(() => {
			if (this.num > 0) {
				this.num--;
			} else {
				this.num = 0;
				clearInterval(interval);
			}
		}, 1000);

		// 4.如果状态可用则停止倒计时器
		if (this.detailPageData.status === 1 && this.detailPageData.subStatus !== 1) {
			setTimeout(() => {

				// 4-1.显示图表
				this.showEchars = true;

				// 4-2.清理倒计时定时器
				clearInterval(interval);

			}, 3000);

		}

		// 5.浏览器监听切换事件
		document.addEventListener('visibilitychange', function () {
			if (document.visibilityState == 'hidden') {
				// 5-1.停止绘制
			} else {
				// 5-2.页面切换回来后再次开始绘制
				// that.drawInterval = setInterval(() => {
					
				// }, 1000);
			}
		});



		if (this.chart1 == null) {
			this.chart1 = this.$echarts.init(
				this.$refs.RefChart1,
				null,
				{
					devicePixelRatio: 2.5,
				}
			);
		}


		if (this.chart2 == null) {
			this.chart2 = this.$echarts.init(
				this.$refs.RefChart2,
				null,
				{
					devicePixelRatio: 2.5,
				}
			);
		}


		// 打开状态 WebSocket
		this.openStatusWebSocket();

		// 打开画线 WebSocket
		// if ((this.detailPageData.status == 1 && this.detailPageData.subStatus != 1) || ((this.detailPageData.status == 5 || this.detailPageData.status == 6) && this.detailPageData.subStatus != 1)) {
			if (!this.stompClient) {
				this.openWebSocket();
			}
		// }


	},
	methods: {
		tipAlertClickSureWqsn() {
			this.isShowTipAlertWqsn = false;
			this.editAbnormalTimeToitet();
		},
		tipAlertClickCancelWqsn() {
			this.isShowTipAlertWqsn = false;
		},
		setAlarmBpm() {
			this.$post(
					'/api/dean/v5/setHealthAlarmConfig',
					{
						"bedId": this.detailPageData.bedId,
						"breathFast": this.alarmModel.breathFast
					},
					(res) => {
						if (res.code == 0) {
							// 2.弹窗
							this.isShowAlarmSetAlert = false;
						} else {
							this.$message.error(res.msg);
						}
					},
					(err) => {
						// this.$message.error('服务端发生异常');
					}
				);
		},
		handleChange(value) {
			let tempAlarmModel = JSON.parse(JSON.stringify(this.alarmModel));
			tempAlarmModel.breathFast = value;
			this.alarmModel = tempAlarmModel;
			console.log(`selected ${value}`);
		},
		handleBlur() {
			console.log('blur');
		},
		handleFocus() {
			console.log('focus');
		},
		filterOption(input, option) {
			console.log('filterOption');
			return false;
			return (
				option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
			);
		},
		changeTempBpm(value) {
			this.tempBreathBpm = value;
		},
		// 打开定时器
		openTimer() {
			if (this.createDataInterval) {
				clearInterval(this.createDataInterval);
				this.createDataInterval = null;
			}
			this.createDataInterval = setInterval(() => {
				this.timerTask();
			}, 10); // 每隔0.01秒执行定时器任务
		},
		// 定时器执行任务
		timerTask() {
			if (!this.websocketData) return;
			// 定时器记录数字保持在 1000 避免太大
			if (this.createDataIntervalCount == 7000) {
				this.createDataIntervalCount = 0;
			}
			this.createDataIntervalCount++;

			// 每秒 创造数据
			if (this.createDataIntervalCount % 100 == 0) {
				if (!this.websocketData) {
					return
				}
				this.changeBreathArrNew();
				this.changeHeartArrNew();
			}

			// 每秒 创造数据
			if (this.createDataIntervalCount % 6000 == 0) {
				this.changeArithmetic(0);
			}

			// 每毫秒更新呼吸率一个点
			if (this.createDataIntervalCount % 10 == 0) {
				// 呼吸率
				if (this.breathDatas.length > 0) {
					let tempBreatheDatas = JSON.parse(JSON.stringify(this.breathDatas))

					let breathArr = [];
					breathArr = this.paintBreathDatas;
					breathArr.unshift(this.breathDatas[0])
					tempBreatheDatas.splice(0, 1)
					this.breathDatas = tempBreatheDatas;
					if (breathArr.length > (672.0 / 2.0) + 10) {
						breathArr.splice(breathArr.length - 1, 1)
					}
					this.paintBreathDatas = breathArr;

				}
			}

			// 每豪豪秒更新一个点
			if (this.heartDatas.length > 0) {
				// 1.拿到当前显示图表数据
				let heartArr = JSON.parse(JSON.stringify(this.paintHeartDatas || []));
				// 2.拿到创造好的数据
				let tempHeartDatas = JSON.parse(JSON.stringify(this.heartDatas))
				// 3.定义间隔距离
				const space = 30;
				// 4.判断显示图表的数据 如果再添加数据 是否超出了屏幕宽度
				if (heartArr.length >= this.maxWidth) {
					if (this.paintHeartDatasCurrentIndex >= this.maxWidth) {
						heartArr[this.paintHeartDatasCurrentIndex - this.maxWidth] = '-';
					} else {
						if (this.paintHeartDatasCurrentIndex + space < this.maxWidth) {
							heartArr[this.paintHeartDatasCurrentIndex + space] = '-';
						}
						heartArr[this.paintHeartDatasCurrentIndex] = tempHeartDatas[0]; // 真正控制间距的位置
						tempHeartDatas.splice(0, 1);
						this.heartDatas = JSON.parse(JSON.stringify(tempHeartDatas));
					}
				} else {
					heartArr.push(tempHeartDatas[0]);
					tempHeartDatas.splice(0, 1);
					this.heartDatas = JSON.parse(JSON.stringify(tempHeartDatas));
				}

				if (this.paintHeartDatasCurrentIndex >= this.maxWidth + space) {
					this.paintHeartDatasCurrentIndex = 0;
				} else {
					this.paintHeartDatasCurrentIndex += 1;
				}
				this.paintHeartDatas = JSON.parse(JSON.stringify(heartArr));
			}

			if (this.createDataIntervalCount % 10 == 0) {
				if (this.paintBreathDatas.length > 0) {
					this.chart1.setOption(get_alarm_detail_breathe_chart_option(this.completionBreatheArray(this.paintBreathDatas), this.breatheColor));
				}
			}
			if (this.createDataIntervalCount % 3 == 0) {
				if (this.paintHeartDatas.length > 0) {
					this.chart2.setOption(get_alarm_detail_heart_chart_option(this.completionHeartArray(this.paintHeartDatas), this.heartColor, [this.paintHeartDatasCurrentIndex + 4, this.paintHeartDatas[this.paintHeartDatasCurrentIndex - 1]]));
				}
			}
		},
		completionBreatheArray(arr) {
			let num = 346 - arr.length;
			let needArr = JSON.parse(JSON.stringify(arr));
			for (let i = 0; i < num; i++) {
				needArr.push('-');
			}
			return needArr;
		},
		completionHeartArray(arr) {
			let num = this.maxWidth - arr.length;
			let needArr = JSON.parse(JSON.stringify(arr));
			for (let i = 0; i < num; i++) {
				needArr.push('-');
			}
			return needArr;
		},
		// 创建 呼吸率 数据
		changeBreathArrNew() {
			// console.log('==================SN', this.detailPageData.sn)
			if (this.breathDatas.length > 10) {
				return;
			}
			// 计算
			let newBreathBpm = this.breathBpm == '--' ? 15 : this.breathBpm;
			let BreathWave_f;
			let BreathWave_Ytemp = [];
			BreathWave_f = newBreathBpm / 60.0;

			let Buff_BreathWave_Y_Flt_temp = this.Buff_BreathWave_Y_Flt;
			let Phi_temp = this.Phi;
			let tempBreatheDatas = JSON.parse(JSON.stringify(this.breathDatas))

			for (let i = 0; i < 10; i++) {
				let tempSin = 5 * Math.cos(((2 * 3.14 * BreathWave_f) / 10.0) * (i + 1) + Phi_temp);
				Buff_BreathWave_Y_Flt_temp.push(tempSin);
				Buff_BreathWave_Y_Flt_temp.splice(0, 1);
				let Buff_BreathWave_Y_FltSum = Buff_BreathWave_Y_Flt_temp.reduce(function (a, b) { return a + b });
				if (this.breathBpm == 0) {
					BreathWave_Ytemp.push(-5);
				} else {
					BreathWave_Ytemp.push(Buff_BreathWave_Y_FltSum);
				}
			}
			Phi_temp = (Phi_temp + ((2 * 3.14 * BreathWave_f) / 10) * 11) % (2 * 3.14);

			// 数组优化
			let breathDatas_temp = tempBreatheDatas.concat(BreathWave_Ytemp);

			// 计算结果赋值
			this.Phi = Phi_temp;
			this.breathDatas = breathDatas_temp;
			this.Buff_BreathWave_Y_Flt = Buff_BreathWave_Y_Flt_temp;
		},

		// 创建 心率 数据
		changeHeartArrNew() {
			if (this.heartDatas.length > 100) {
				return;
			}
			// 计算
			let newHeartBpm = this.heartBpm == '--' ? 70 : this.heartBpm;
			let HeartWave_Y = [];
			if (newHeartBpm > 80) {
				newHeartBpm = 80;
			} else if (newHeartBpm < 65) {
				newHeartBpm = 65;
			}
			let RR = (60 / newHeartBpm) * 1000;
			let T_cnt_new = Math.round((RR / 1000) * 100);
			let HeartWave_TP_cnt = T_cnt_new - 66;

			let pointer_temp = this.pointer;
			let HeartWave_Y_Mode_temp = JSON.parse(JSON.stringify(this.HeartWave_Y_Mode));
			let T_cnt_present_temp = this.T_cnt_present;
			let tempHeartDatas = JSON.parse(JSON.stringify(this.heartDatas))

			for (let i = 0; i < 100; i++) {
				pointer_temp = pointer_temp + 1;
				HeartWave_Y.push(HeartWave_Y_Mode_temp[pointer_temp - 1]);
				if (pointer_temp >= T_cnt_present_temp) {
					let zerosArr = [];
					for (let index = 0; index < HeartWave_TP_cnt; index++) {
						zerosArr.push(0);
					}
					HeartWave_Y_Mode_temp = this.Buff_Electrocardiogram_QRST.concat(
						zerosArr,
						this.Buff_Electrocardiogram_PR
					);
					T_cnt_present_temp = HeartWave_Y_Mode_temp.length;
					pointer_temp = 0;
				}
			}

			// 数组优化
			let heartDatas_temp = tempHeartDatas.concat(HeartWave_Y);

			// 计算结果赋值
			this.HeartWave_Y_Mode = HeartWave_Y_Mode_temp;
			this.T_cnt_present = T_cnt_present_temp;
			this.pointer = pointer_temp;
			this.heartDatas = heartDatas_temp;
		},
		setLeaveBed() {

		},
		updateStatusShow(tempStatus, tempSubStatus, tempStatusName, tempDuration) {
		},
		changeArithmetic(operationType) {
		},
		openWebSocket() {
			if (this.stompClient != null) {
				this.stompClient.unsubscribe();
				this.stompClient.disconnect();
				this.stompClient = null;
			}

			// 1.默认已离床时间为空
			this.duration = '';

			// 建立连接对象
			let id = this.detailPageData.sn;
			var wsUrl = this.$store.state.baseUrl + '/api/ws/event';
			if (wsUrl.indexOf('http://') === 0) {
				wsUrl = wsUrl.replace('http://', 'ws://');
			} else if (wsUrl.indexOf('https://') === 0) {
				wsUrl = wsUrl.replace('https://', 'wss://');
			} else {
				wsUrl = wsUrl;
			}
			this.socket = new WebSocket(wsUrl); // 路径
			this.stompClient = Stomp.over(this.socket);
			this.stompClient.debug = null;
			let headers = {
				Authentication: this.getCookie('userInfo').token, // 获取token
			};
			this.stompClient.connect(headers, (frame) => {
				this.stompClient.subscribe('/topic/bedRealTime.' + id, (msg) => {
					// console.log('AlarmDetailBreatheHeart - 收到socket推送的消息:', msg.body)
					let data = JSON.parse(msg.body);
					if (data) {
						/**
						 * 处理离床、离线、关闭情况
						 */
						if (data.obfg == true || data.status == 2 || data.status == 3 || data.status == 4) { // 离床 || 离床 || (离线 || 关闭)
							this.showEchars = false;
							this.setLeaveBed();
						}

						if (data.heartBpm == '255' || data.heartBpm == '255') {
							this.showEchars = false;
							this.statusName = '离床'
							this.setLeaveBed();
						}

						if (data.status === 1) {
							this.showEchars = true;
						}

						let socketData = JSON.parse(msg.body);
						// 5.圆点颜色
						if (socketData.heartBpm >= socketData.heartStatus[0] && socketData.heartBpm <= socketData.heartStatus[1]) {
								this.circleBackground = '#53c31b';
							} else {
								this.circleBackground = '#FF4D4F';
							}

						// 6.房间状态 - 赋值
						this.roomStatus = socketData.status;

						// 7.低中高
						this.computedBreathPosition(
							socketData.breathStatus,
							socketData.breathBpm
						);
						this.computedHeartPosition(
							socketData.heartStatus,
							socketData.heartBpm
						);

						// 8.获取设备当前状态的描述文案 | 末端渐变色
						this.getMonitorStatusStr(socketData);
						this.getEndColor(socketData.stableNum);

						// 9.
						if (socketData.status === 3 || socketData.status === 4) {
							this.isShowGray = 1;
						} else {
							this.isShowGray = 2;
						}
						// 10.
						if (socketData.status === 2) {
							this.showEchars = false;
							this.isBeginDrawechars = true;
							this.isOutBed = this.isOutBed + 1;
							this.breathBPM = '--';
							this.isShowRedBreath = 2;
							this.heartBPM = '--';
							this.isShowRedHeart = 2;
							if (this.isOutBed >= 1) {
								this.computedLeaveBed(socketData.duration);
							} else {
								clearInterval(this.leaveBedInterval);
								this.duration = ''
							}
						} else {
							this.isOutBed = 0;
							clearInterval(this.leaveBedInterval);
							this.duration = ''
						}

						// 11.离床报警赋值
						this.detailPageData.hasAlarm = socketData.outBedAlarm;


						/**
						 * 处理寻常画线情况
						 */
						 this.websocketData = data;
						 this.heartBpm = data.heartBpm == 255 ? '--' : data.heartBpm;
						 this.breathBpm = data.breathBpm == 255 ? '--' : data.breathBpm;
						 this.stableNum = data.stableNum;
						 this.isShowStableNum = true;
						 this.showBreatheBpm = this.breathBpm;
						 this.showHeartBpm = this.heartBpm;
						// 处理进度条
						if (data.stableNum > 0) {
							let tempArr = [];
							for (let j = 0; j < Math.floor(data.stableNum / 5.0); j++) {
								tempArr.push('1');
							}
							this.progressArr = tempArr;
						} else {
							this.progressArr = [];
						}
						// 判断创造数据的定时器是否存在
						if (!this.createDataInterval) {
							this.openTimer();
						}

						if (data.status == 1) { // 1-监测时段正常
							// 1-离床 2-清醒 3-浅睡 4-深睡 5-无人 6-有人
							if (data.breathStatus.length == 2) {
								if (this.breathBpm >= data.breathStatus[0] && this.breathBpm <= data.breathStatus[1]) {
									this.breatheColor = '#1890ff';
									this.breatheImageName = 'icon_alarm_detail_state_6.png';
								} else {
									this.breatheColor = '#1890ff';
									this.breatheImageName = 'icon_alarm_detail_state_2.png';
								}
							} else {
								this.breatheColor = '#1890ff';
								this.breatheImageName = 'icon_alarm_detail_state_6.png';
							}
							if (data.heartStatus.length == 2) {
								if (this.heartBpm >= data.heartStatus[0] && this.heartBpm <= data.heartStatus[1]) {
									this.heartColor = '#52C419';
									this.heartImageName = 'icon_alarm_detail_state_1.png';
								} else {
									this.heartColor = '#53c31b';
									this.heartImageName = 'icon_alarm_detail_state_3.png';
								}
							} else {
								this.heartColor = '#52C419';
								this.heartImageName = 'icon_alarm_detail_state_1.png';
							}
						} else if (data.status == 5 || data.status == 6) { // 5-异常事件报警 6-异常已消音(原处理中)
							// 1-离床过久 2-跌倒 4呼吸过速 5呼吸过缓 7心跳过速 8心跳过缓 9卫生间停留过久
							if (data.subStatus == 1) {
								this.breatheColor = '#FF4D4F';
								this.heartColor = '#FF4D4F';
							} else {
								if (data.breathStatus.length == 2) {
									if (this.breathBpm >= data.breathStatus[0] && this.breathBpm <= data.breathStatus[1]) {
										this.breatheColor = '#1890ff';
										this.breatheImageName = 'icon_alarm_detail_state_6.png';
									} else {
										this.breatheColor = '#FF4D4F';
										this.breatheImageName = 'icon_alarm_detail_state_2.png';
									}
								} else {
									this.breatheColor = '#1890F';
									this.breatheImageName = 'icon_alarm_detail_state_6.png';
								}
								if (data.heartStatus.length == 2) {
									if (this.heartBpm >= data.heartStatus[0] && this.heartBpm <= data.heartStatus[1]) {
										this.heartColor = '#52C419';
										this.heartImageName = 'icon_alarm_detail_state_1.png';
									} else {
										this.heartColor = '#FF4D4F';
										this.heartImageName = 'icon_alarm_detail_state_3.png';
									}
								} else {
									this.heartColor = '#52C419';
									this.heartImageName = 'icon_alarm_detail_state_1.png';
								}
							}
						}
					}

				});
			}, (err) => {
				this.openWebSocket();
			});
		},

		// 状态 WebSocket
		openStatusWebSocket() {
			if (this.statusStompClient != null) {
				this.statusStompClient.unsubscribe();
				this.statusStompClient.disconnect();
				this.statusStompClient = null;
			}

			// 1.Websocket开始连接
			let id = this.detailPageData.bedId;
			var wsUrl = this.$store.state.baseUrl + '/api/ws/event';
			if (wsUrl.indexOf('http://') === 0) {
				wsUrl = wsUrl.replace('http://', 'ws://');
			} else if (wsUrl.indexOf('https://') === 0) {
				wsUrl = wsUrl.replace('https://', 'wss://');
			} else {
				wsUrl = wsUrl;
			}
			this.statusSocket = new WebSocket(wsUrl); // 路径
			this.statusStompClient = Stomp.over(this.statusSocket);
			this.statusStompClient.debug = null;
			let headers = {
				Authentication: this.$getCookie('userInfo').token, // 获取token
			};
			this.statusStompClient.connect(headers, (frame) => {
				this.statusStompClient.subscribe('/topic/bedStatus.' + id, (msg) => {
					// console.log('AlarmDetailRestRoom - bedStatus - 收到socket推送的消息:', msg.body)
					let tempData = JSON.parse(msg.body);
					if (tempData) {
						this.updateStatusShow(tempData.status, tempData.subStatus, tempData.statusName, tempData.duration || 0);
						// 打开画线 WebSocket
						if ((tempData.status == 1 && tempData.subStatus != 1) || ((tempData.status == 5 || tempData.status == 6) && tempData.subStatus != 1)) {
							if (!this.stompClient) {
								this.openWebSocket();
							}
						}
						if ((tempData.status == 1 && tempData.subStatus == 1)) {
							this.setLeaveBed();
						}
						if (((tempData.status == 5 || tempData.status == 6) && tempData.subStatus == 1)) {
							this.setLeaveBed();
						}

						// 1.推送收到的数据
						let socketData = JSON.parse(msg.body);

						// 2.
						if (socketData.status === 3 || socketData.status === 4) {
							this.isShowGray = 1;
							this.showEchars = false;
							clearInterval(this.intervalPulsSecond);
						} else {
							this.isShowGray = 2;
							this.showEchars = true;
						}

						// 3.
						if (socketData.status === 2) {
							clearInterval(this.intervalPulsSecond);
							clearInterval(this.breathInterval);
							clearInterval(this.heartInterval);
						}

						// 4.
						if (socketData.status === 1) {
							setTimeout(() => {
								clearInterval(this.heartInterval);
								clearInterval(this.breathInterval);
								clearInterval(this.intervalPulsSecond);
								let length = this.breathYdataCopy.length;

								for (let i = 0; i < 400 - length; i++) {
									this.breathYdataCopy.push(0);
								}
								setTimeout(() => {
								}, 1000);
							}, 10000);
						}

						// 5.
						this.detailPageData.status = socketData.status;
						this.detailPageData.subStatus = socketData.subStatus;
						this.detailPageData.statusName = socketData.statusName;


					}
				});

			}, (err) => {
				this.openStatusWebSocket();
			});
		},












		computedLeaveBed(value) {
			if (this.duration != '') {
				return
			}
			let falg = 0;
			if (this.leaveBedInterval) {
				clearInterval(this.leaveBedInterval);
			}
			if (value) {
				this.duration = this.formatSeconds(value + falg);
				this.leaveBedInterval = setInterval(() => {
					falg++;
					this.duration = this.formatSeconds(value + falg);
				}, 1000);
			}
		},
		
		// 关闭 Websocket
		closeWebsocket() {
			if (this.stompClient) {
				this.stompClient.disconnect();
				this.stompClient = null;
				this.socket = null;
			}
			if (this.statusStompClient) {
				this.statusStompClient.disconnect();
				this.statusStompClient = null;
				this.statusSocket = null;
			}
		},
		// 获取床位信息
		getBedInfoById(bedId) {
			let params = {
				bedId: bedId,
			};
			this.$get(
				'/api/v3/bed/getBedInfoById',
				params,
				(res) => {
					if (res.code === 0) {
						if (!res.data) {
							return;
						}
						this.switchStatus =
							res.data.monitorInfoVO.onOff === 0 ? false : true;
						this.bedSetId = res.data.bedId;
						this.radarId = res.data.radarId;
					}
				},
				(err) => {
					console.log(err);
				}
			);
		},
		// 设置监测仪状态
		setStatus() {
			this.num = 10;
			this.isTextarea = this.switchStatus ? false : true;
			let param = {
				bedId: this.detailPageData.bedId,
				onOff: this.switchStatus ? 1 : 0,
			};
			this.$put(
				'/api/monitor/onOff',
				param,
				(res) => {
					if (res.code == 0) {
						if (this.switchStatus == 1) {
							this.$message.success('监测仪已开启');
						} else {
							this.$message.success('监测仪已关闭');
						}
						this.$emit('getHistoryList');
						this.isShowGray = 1;
					}
				},
				(err) => { }
			);
		},
		// 卫生间停留时长取消
		editAbnormalTimeCancelOutBed() {
			this.editAbnormalTimePopupOutBed = false;
		},
		editAbnormalTimeToitetNewNew() {
			this.$get(
				'/api/bedInformation/getLivingState',
				{
					"bedId": this.detailPageData.bedId
				},
				(res) => {
					if (res.code == 0) {
						if (res.data == 4) { // 完全失能
							this.editAbnormalTimeToitetNew(true)
						} else {
							this.editAbnormalTimeToitetNew(false)
						}
					} else {
						this.editAbnormalTimeToitetNew(false)
					}
				},
				(err) => {
					this.editAbnormalTimeToitetNew(false)
				}
			);
		},
		editAbnormalTimeToitetNew(isWqsn) {

			let isChange = false;
			if (isWqsn) {
				if (this.compareOldTimePeriods && this.getFallLongTimeData && this.getFallLongTimeData.timePeriods) {
					let oldTimePeriods = JSON.parse(JSON.stringify(this.compareOldTimePeriods));
					let tempChangedTimePeriods = JSON.parse(JSON.stringify(this.getFallLongTimeData.timePeriods));
					let newTimePeriods = [];
					if (tempChangedTimePeriods.length > 0) {
						for (let i = 0; i < tempChangedTimePeriods.length; i++) {
							let needStartTime;
							let needEndTime;
							let needEditHandleTimeValOutBed = this.$dateTime(tempChangedTimePeriods[i].editHandleTimeValOutBed).time + ':' + this.$dateTime(tempChangedTimePeriods[i].editHandleTimeValOutBed).seconds;
							if (!tempChangedTimePeriods[i] || !tempChangedTimePeriods[i].editHandleTimeValOutBed) {
								needEditHandleTimeValOutBed = ''
							}
							needStartTime = this.$dateTime(tempChangedTimePeriods[i].startTime).time;
							needEndTime = this.$dateTime(tempChangedTimePeriods[i].endTime).time;
							let obj = {
								bedId: tempChangedTimePeriods[i].bedId,
								endTime: needEndTime,
								id: tempChangedTimePeriods[i].id,
								outBedAlarmTime: needEditHandleTimeValOutBed,
								startTime: needStartTime,
								outBedEnable: tempChangedTimePeriods[i].outBedEnable,
								outBedPhoneEnable: tempChangedTimePeriods[i].outBedPhoneEnable
							}
							newTimePeriods.push(obj)
						}

						if (this.compareOldTimePeriods && newTimePeriods && this.compareOldTimePeriods.length == newTimePeriods.length) {
							for (let i = 0; i < newTimePeriods.length; i++) {
								let item = newTimePeriods[i];
								let otherItem = this.compareOldTimePeriods[i];
								if (item.startTime != otherItem.startTime) {
									isChange = true;
								}
								if (item.endTime != otherItem.endTime) {
									isChange = true;
								}
								if (item.outBedAlarmTime != otherItem.outBedAlarmTime) {
									isChange = true;
								}
								if (item.outBedEnable != otherItem.outBedEnable) {
									isChange = true;
								}
								if (item.outBedPhoneEnable != otherItem.outBedPhoneEnable) {
									isChange = true;
								}
							}
						}
					}
				}
			}
			
			if (isWqsn) {
				// 1.判断监测时间段、离床异常时长是否被修改了
				if (isChange) {
					// 2.判断是否每次设置成完全是能用户后的第一次修改进行提示
					this.$get('/api/bedInformation/livingStateDoNum', {"bedId": this.detailPageData.bedId}, (res) => {
						if (res.code == 0) {
							if (res.data == 1) {
								this.isShowTipAlertWqsn = true;
							} else {
								this.editAbnormalTimeToitet();
							}
						} else {
							this.$message.error(res.msg);
						}
					},
					(err) => {
						console.log(err);
						// this.$message.error('服务端发生异常');
					});
				} else {
					this.editAbnormalTimeToitet();
				}
			} else {
				this.editAbnormalTimeToitet();
			}
		},
		// 卫生间停留时长确定
		editAbnormalTimeToitet() {
			// 1.设置呼吸过速阈值报警
			this.setAlarmBpm();

			// 2.老代码
			let len = this.relateWC_treeData_value_Sel_Next.length;
			let fallId = this.relateWC_treeData_value_Sel_Next[len - 1];
			let timePeriods = this.getFallLongTimeData.timePeriods
			let new_timePeriods = []
			if (timePeriods.length > 0) {
				for (let i = 0; i < timePeriods.length; i++) {
					let needStartTime;
					let needEndTime;
					let needOutBedAlarmTime = this.$dateTime(timePeriods[i].editHandleTimeValOutBed).time + ':' + this.$dateTime(timePeriods[i].editHandleTimeValOutBed).seconds;
					if (!timePeriods[i] || !timePeriods[i].editHandleTimeValOutBed) {
						needOutBedAlarmTime = ''
					}
					if (timePeriods[i].outBedEnable == 0 && (!timePeriods[i] || !timePeriods[i].editHandleTimeValOutBed)) {
						this.$message.error('请选择时间');
						return
					}
					needStartTime = this.$dateTime(timePeriods[i].startTime).time;
					needEndTime = this.$dateTime(timePeriods[i].endTime).time;
					let obj = {
						bedId: timePeriods[i].bedId,
						endTime: needEndTime,
						id: timePeriods[i].id,
						// outBedAlarmTime: this.$dateTime(this.editHandleTimeValOutBed._d).time + ':' + this.$dateTime(this.editHandleTimeValOutBed._d).seconds,
						outBedAlarmTime: needOutBedAlarmTime || null,
						startTime: needStartTime,
						outBedEnable: timePeriods[i].outBedEnable,
						outBedPhoneEnable: timePeriods[i].outBedPhoneEnable
					}
					new_timePeriods.push(obj)
				}
			}
			let param = {
				radarId: this.radarId,
				fallId: fallId,
				outBedTimeout: this.$dateTime(this.editHandleTimeValOutBed._d).time + ':' + this.$dateTime(this.editHandleTimeValOutBed._d).seconds,
				timePeriods: new_timePeriods
			};
			this.$post(
				'/api/radar/radarFallAndSetOutTime',
				param,
				(res) => {
					if (res.code == 0) {
						this.$message.success('修改成功');

						this.editAbnormalTimePopupOutBed = false;
					} else {
						this.$message.error(res.msg);
					}
				},
				(err) => {
					console.log(err);
					// this.$message.error('服务端发生异常');
				}
			);
		},
		// 设置卫生间停留时长
		setToitet() {
			this.$get(
				'/api/dean/v5/getHealthAlarmConfig',
				{
					"bedId": this.detailPageData.bedId
				},
				(res) => {
					if (res.code == 0) {
						this.alarmModel = null;
						setTimeout(() => {
							this.alarmModel = res.data;
							this.setToitet1();
						}, 300);
					} else {
						console.log(res.msg);
					}
				},
				(err) => {
					console.log(err);
				}
			);
		},
		setToitet1() {
			this.editAbnormalTimePopupOutBed = true;
			let param = {
				bedId: this.bedSetId,
			};
			this.$get(
				'/api/app/v1/getFallLongTime',
				param,
				(res) => {
					if (res.code == 0) {
						let tempData = JSON.parse(JSON.stringify(res.data));
						if (tempData.timePeriods && tempData.timePeriods.length > 0) {
							for (let i = 0; i < tempData.timePeriods.length; i++) {
								tempData.timePeriods[i].editHandleTimeValOutBed = tempData.timePeriods[i].outBedAlarmTime ? this.$moment(tempData.timePeriods[i].outBedAlarmTime, 'HH:mm:ss') : '';
							} 
						}
						this.getFallLongTimeData = tempData
						this.OutBeddisabled = res.data.hasConsumer;
						this.editHandleTimeValOutBed = res.data.outBedTime ? this.$moment(res.data.outBedTime, 'HH:mm:ss') : '';
						this.compareOldTimePeriods = JSON.parse(JSON.stringify(this.getFallLongTimeData.timePeriods));
						
						let timePeriods = this.getFallLongTimeData.timePeriods
						if (timePeriods && timePeriods.length > 0) {
							for (let i = 0; i < timePeriods.length; i++) {
								timePeriods[i].startTime += ':00';
								timePeriods[i].startTime = this.$moment(timePeriods[i].startTime, 'HH:mm:ss');
								timePeriods[i].endTime += ':00';
								timePeriods[i].endTime = this.$moment(timePeriods[i].endTime, 'HH:mm:ss');
							}
						}
						this.getFallLongTimeData.timePeriods = timePeriods
					}
				},
				(err) => { }
			);
			this.getFallRelationTree();
			this.getFallRelation();
		},
		// 获取关联弹窗内树形结构
		getFallRelationTree() {
			this.$get(
				'/api/radar/getFallRelationTree',
				{},
				(res) => {
					if (res.code == 0) {
						this.relateWC_treeData = res.data.children;
					}
				},
				(err) => {
					console.log(err);
					// this.$message.error('服务端发生异常');
				}
			);
		},
		// 获取查看关联
		getFallRelation() {
			this.$get(
				'/api/radar/getFallRelation',
				{
					radarId: this.radarId,
				},
				(res) => {
					if (res.code == 0) {
						this.relateWC_treeData_value = res.data; //当前值 为进入查看时的值
						this.relateWC_treeData_value_Sel_Prev = this.relateWC_treeData_value; //选中前的值
						this.relateWC_treeData_value_Sel_Next = this.relateWC_treeData_value; //选中后的值
					}
				},
				(err) => {
					// this.$message.error('服务端发生异常');
				}
			);
		},
		// 点击选择
		change_relateWC(value) {
			this.relateWC_treeData_value_Sel_Next = value; //赋值选中后的新值

			if (this.relateWcType == 1) {
				// 查看关联
				if (value.length < 1) {
					// 当前选中后为空,执行的叉子操作
					// 选中前的值等于默认的值
					if (
						this.relateWC_treeData_value_Sel_Prev ==
						this.relateWC_treeData_value
					) {
						this.del_relateWC_Tan = true; //二次确认弹窗
					}
				} else {
					//如果不为空，为赋值操作，选中后的值赋值给选中前的值
					this.relateWC_treeData_value_Sel_Prev = this.relateWC_treeData_value_Sel_Next;
				}
			} else if (this.relateWcType == 2) {
				// 关联卫生间
				console.log('关联卫生间无需操作');
			}
		},
		// 获取设备当前状态的描述文案
		getMonitorStatusStr(resData) {
			if (resData.status === 1) {
				this.monitorStatusStr = '真棒，实时监测中';
				if (!resData.isOffline) {
					this.monitorStatusStr = '监测仪离线';
				} else {
					if (!resData.isSignal) {
						this.monitorStatusStr = '信号似乎不太好哦';
					} else {
						if (resData.stableNum <= 59) {
							this.monitorStatusStr = '动作有点大哦，现在的呼吸率和心率不稳定，请尽量保持稳定';
						}
						if (resData.stableNum >= 60 && resData.stableNum <= 79) {
							this.monitorStatusStr = '您正在接近稳定噢，再努力一点点';
						}
						if (resData.stableNum >= 80) {
							this.monitorStatusStr = '真棒，实时监测中';
						}
						if (resData.tcfg === 1) {
							this.monitorStatusStr = '距离有点近哦，请调整与设备的距离';
						}
					}
				}
			} else if (resData.status === 2) {
				if (this.detailPageData.statusName == '疑似生命体征微弱') {
					this.monitorStatusStr = this.detailPageData.statusName;
				} else {
					this.monitorStatusStr = '已离床';
				}
			} else if (resData.status === 3) {
				this.monitorStatusStr = '监测仪离线';
			} else if (resData.status === 4) {
				this.monitorStatusStr = '监测关闭';
			} else if (resData.status === 5) {
				this.monitorStatusStr = '设备异常';
			}
		},
		// 获取渐变色结束颜色
		getEndColor(data) {
			this.stableNum = data;
			let colorArr = ['#CCA20F', '#BEA813', '#AEAE18', '#A2B520', '#95BB25', '#87BF29', '#7AC62E', '#6CC932', '#61CE36', '#65E332', '#65E332']
			let index = 0;
			if (data < 8) index = 0;
			if (data >= 8 && data < 16) index = 1;
			if (data >= 16 && data < 24) index = 2;
			if (data >= 24 && data < 32) index = 3;
			if (data >= 32 && data < 40) index = 4;
			if (data >= 40 && data < 48) index = 5;
			if (data >= 48 && data < 56) index = 6;
			if (data >= 56 && data < 64) index = 7;
			if (data >= 64 && data < 72) index = 8;
			if (data >= 72 && data < 80) index = 9;
			if (data >= 80) index = 10;
			this.endColor = colorArr[index];
		},
		computedBreathPosition(breathStatus, breathBpm) {
			let breathPositionStr = '';
			// 低
			if (breathBpm < breathStatus[0]) {
				this.isShowRedBreath = 1;
				breathPositionStr =
					(25 / 100 / breathStatus[0]) * breathBpm * 100 + '%';
			}
			// 中
			if (breathBpm >= breathStatus[0] && breathBpm <= breathStatus[1]) {
				this.isShowRedBreath = 2;
				breathPositionStr =
					(50 / 100 / (breathStatus[1] - breathStatus[0])) *
					(breathBpm - breathStatus[0]) *
					100 +
					25;
				if (breathPositionStr > 65) {
					breathPositionStr = 65;
				}
				breathPositionStr = breathPositionStr + '%';
			}
			// 高
			if (breathBpm > breathStatus[1]) {
				this.isShowRedBreath = 3;
				breathPositionStr =
					(25 / 100 / breathStatus[0]) * (breathBpm - breathStatus[1]) * 100 +
					65;
				if (breathPositionStr > 90) {
					breathPositionStr = 90;
				}
				breathPositionStr = breathPositionStr + '%';
			}
			if (breathBpm >= 255) {
				this.isShowRedBreath = 2;
				this.breathBPM = '--';
			}
			this.breathPosition = breathPositionStr;
		},
		computedHeartPosition(heartStatus, heartBpm = 0) {
			let breathPositionStr = '';
			// 低
			if (heartBpm < heartStatus[0]) {
				this.isShowRedHeart = 1;
				breathPositionStr = (25 / 100 / heartStatus[0]) * heartBpm * 100 + '%';
			}
			// 中
			if (heartBpm >= heartStatus[0] && heartBpm <= heartStatus[1]) {
				this.isShowRedHeart = 2;
				breathPositionStr =
					(50 / 100 / (heartStatus[1] - heartStatus[0])) *
					(heartBpm - heartStatus[0]) *
					100 +
					25;
				if (breathPositionStr > 65) {
					breathPositionStr = 65;
				}
				breathPositionStr = breathPositionStr + '%';
			}

			// 高
			if (heartBpm > heartStatus[1]) {
				this.isShowRedHeart = 3;
				breathPositionStr =
					(25 / 100 / heartStatus[0]) * (heartBpm - heartStatus[1]) * 100 + 65;
				if (breathPositionStr > 90) {
					breathPositionStr = 90;
				}
				breathPositionStr = breathPositionStr + '%';
			}
			if (heartBpm >= 255) {
				this.isShowRedHeart = 2;
				this.heartBPM = '--';
			}
			this.heartPosition = breathPositionStr;
		},
		// 获取 cookie 信息
		getCookie(c_name) {
			var name = c_name + '=';
			var ca = document.cookie.split(';');
			for (var i = 0; i < ca.length; i++) {
				var c = decodeURIComponent(ca[i].trim()); // 解码
				if (c.indexOf(name) == 0) {
					return JSON.parse(c.substring(name.length, c.length));
				}
			}
			return '';
		},
		// 转时分秒
		formatSeconds(value) {
			let result = parseInt(value);
			let h =
				Math.floor(result / 3600) < 10
					? '0' + Math.floor(result / 3600)
					: Math.floor(result / 3600);
			let m =
				Math.floor((result / 60) % 60) < 10
					? '0' + Math.floor((result / 60) % 60)
					: Math.floor((result / 60) % 60);
			let s =
				Math.floor(result % 60) < 10
					? '0' + Math.floor(result % 60)
					: Math.floor(result % 60);

			let res = '';
			res += `${h}:${m}:${s}`;

			return res;
		},
		swictchChangeLeaveBedTime(item, index) {
			let getFallLongTimeData = JSON.parse(JSON.stringify(this.getFallLongTimeData));
			if (getFallLongTimeData && getFallLongTimeData.timePeriods && getFallLongTimeData.timePeriods.length > 0) {
				if (getFallLongTimeData.timePeriods[index].outBedEnable == 0) {
					getFallLongTimeData.timePeriods[index].outBedEnable = 1;
				} else {
					getFallLongTimeData.timePeriods[index].outBedEnable = 0;
				}
			}
			this.getFallLongTimeData = getFallLongTimeData;
		},
		swictchChangeLeaveBedPhone(item, index) {
			let getFallLongTimeData = JSON.parse(JSON.stringify(this.getFallLongTimeData));
			if (getFallLongTimeData && getFallLongTimeData.timePeriods && getFallLongTimeData.timePeriods.length > 0) {
				if (getFallLongTimeData.timePeriods[index].outBedPhoneEnable == 0) {
					getFallLongTimeData.timePeriods[index].outBedPhoneEnable = 1;
				} else {
					getFallLongTimeData.timePeriods[index].outBedPhoneEnable = 0;
				}
			}
			this.getFallLongTimeData = getFallLongTimeData;
		},
	},
	beforeDestroy() {
		// console.log('要销毁了～～～～～～～～', this.detailPageData.sn);
		this.closeWebsocket();
		if (this.createDataInterval) {
			clearInterval(this.createDataInterval);
			this.createDataInterval = null;
		}
		if (this.leaveBedInterval) {
			clearInterval(this.leaveBedInterval);
			this.leaveBedInterval = null;
		}
	},
	watch: {
		pageBottomData(newVal, oldVal) {
			if (newVal) {
				this.switchStatus = newVal.monitorInfoVO.onOff === 0 ? false : true;
				this.bedSetId = newVal.bedId;
				this.radarId = newVal.radarId;
			}
		}
	},
};
</script>
<style lang="scss" scoped>
.picker {
	padding-bottom: 10px;

	.titleTime {
		margin-right: 10px;
		margin-bottom: 10px;
	}

	.rJt {
		width: 14px;
		height: 7px;
		margin-left: 5px;
		margin-right: 5px;
	}
}

.toitet-pop-tips {
	margin-top: -20px;
	margin-left: 136px;
	font-size: 14px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #bfbfbf;

	.isLessTime {
		color: #ff4d4f;
	}
}

.toitet-btn {
	margin-top: 20px;
	margin-left: 362px;
}

.ant-modal-body {}

::v-deep .ant-modal-body {
	background: #fff;
}

::v-deep .ant-cascader-picker {
	width: 100%;
}

// 呼吸过速报警阈值 - 修改
::v-deep .ant-btn > i, .ant-btn > span {
	width: 60px;
}

.room-page {
	height: 383px;
	background: #fff;
	display: flex;
	width: 100%;
	border-radius: 0 0 8px 8px;

	.room-left-con {
		position: relative;
		display: flex;
		flex-direction: column;
		margin-bottom: 15px;
	}

	.top {
		width: 100%;
		display: flex;
		align-items: center;
		position: absolute;
		top: 0;
		left: 0;
		z-index: 10;

		.status {
			flex: 1;
			font-size: 12px;
			display: flex;
			flex-direction: column;

			.status-top {
				display: flex;
				height: 28px;
				line-height: 28px;

				.text {
					min-width: 80px;
					margin-right: 8px;
					text-align: center;
					background: linear-gradient(180deg, #ffffff 0%, #eaeaea 100%);
				}

				.text-alarm {
					color: #ff4d4f;
				}

				.bar {
					flex: 1;
					padding-left: 20px;
					background: linear-gradient(180deg, #ffffff 0%, #eaeaea 100%);
				}
			}

			.stable {
				height: 15px;
			}

			.stable-alarm {
				width: 10%;
				height: 15px;
				padding-left: 20px;
			}
		}

		img {
			width: 80px;
			height: 80px;
		}
	}

	.split-line {
		width: 97%;
		position: absolute;
		top: 55.5%;
		left: 50%;
		transform: translate(-50%, -50%);
		height: 1px;
		background-image: linear-gradient(to right,
				#bfbfbf 0%,
				#bfbfbf 50%,
				transparent 50%);
		background-size: 10px 1px;
		background-repeat: repeat-x;
	}

	.grid_line {
		width: 100%;
		height: 100%;
		text-align: center;
		color: blue;
		box-sizing: border-box;
		border: 1px solid rgba(191, 191, 191, 0.1);
		background: -webkit-linear-gradient(top,
				transparent 15px,
				rgba(191, 191, 191, 0.1) 0),
			-webkit-linear-gradient(left, transparent 15px, rgba(191, 191, 191, 0.1) 0);
		background-size: 16px 16px;
	}

	.heart-con {
		position: relative;

		.heart-circle {
			width: 15px;
			height: 15px;
			position: absolute;
			top: 100px;
			left: 0;
			background: #53c31b;
			border: 2px solid #fff;
			border-radius: 50%;
		}
	}

	.echats-con {
		padding-top: 60px;
		position: relative;
		flex: 1;
		width: 880px;
	}

	.room-left {
		flex: 1;
		width: 855px;
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;

		.alarm-icon {
			margin-right: 10px;
		}

		.off-line {
			color: #ff4d4f;
			font-size: 36px;
		}

		.close {
			color: #262626;
			font-size: 36px;
		}

		.leave-bed-alarm {
			color: #ff4d4f;
			font-size: 36px;
		}

		.leave-bed-noalarm {
			color: #53c31b;
			font-size: 36px;
		}
	}

	.londing {
		width: 885px;
		display: flex;
		align-items: center;
		justify-content: center;
		flex: 1;
	}

	.room-right {
		background-image: -webkit-gradient(linear,
				left top,
				right top,
				from(#bfbfbf),
				color-stop(50%, #bfbfbf),
				color-stop(50%, transparent));
		background-image: linear-gradient(to bottom,
				#bfbfbf 50%,
				#bfbfbf 0%,
				transparent 50%);
		background-size: 1px 10px;
		background-repeat: repeat-y;
		margin-bottom: 15px;

		.room-right-con {
			display: flex;
			flex-direction: column;
			height: 100%;
		}

		.switch {
			margin-left: 10px;

			.realTop_left {
				width: 330px;
				padding-top: 10px;
				padding-bottom: 25px;

				.left_header {
					display: flex;
					justify-content: flex-start;
					align-items: center;

					.left_title {
						font-size: 18px;
						font-weight: 400;
						color: #262626;
					}

					.switch-btn-open {
						font-size: 12px;
						color: #ffffff;
						position: absolute;
						top: 3px;
						left: 17px;
					}

					.switch-btn-off {
						font-size: 12px;
						color: #ffffff;
						position: absolute;
						top: 3px;
						left: 32px;
					}

					.title-flex {
						flex: 1;
						display: flex;
						align-items: center;
						justify-content: space-between;

						.title-flex-set {
							color: #1890ff;
							cursor: pointer;
							font-size: 14px;
						}
					}
				}
			}
		}

		.room-icon {
			display: flex;
			align-items: center;
			justify-content: space-around;
			flex-direction: column;
			flex: 1;

			.room-icon-item {
				width: 100%;
				display: flex;
				flex-direction: column;
				align-items: center;

				.item-text {
					display: flex;
					align-items: center;
					justify-content: space-around;
					width: 100%;

					.alarm-conter {
						color: #ff4d4f;
					}
				}

				.item-lin {
					display: flex;
					justify-content: space-between;
					padding: 0 20px 0 10px;
					position: relative;

					.conter-low {
						width: 80px;
						background: #bfbfbf;
						height: 5px;
					}

					.conter {
						flex: 1;
						background: #d9f7be;
						height: 5px;
					}

					.conter-height {
						width: 80px;
						background: #bfbfbf;
						height: 5px;
					}

					.alarm-conter {
						background: #ff9899;
					}

					.position-cirle {
						width: 20px;
						height: 20px;
						background: #5cc726;
						box-shadow: 0px 0px 2px 0px rgba(172, 172, 172, 0.5);
						border: 2px solid #e9ffde;
						border-radius: 50%;
						position: absolute;
						top: -8px;
						left: 0;
					}
				}
			}

			.img_icon {
				display: flex;
				font-size: 68px;
				color: #bfbfbf;
				align-items: center;
				justify-content: space-around;
				width: 180px;
				font-weight: 200;

				.breath-text {
					color: #1890ff;
				}

				.heart-text {
					color: #53c31b;
				}
			}

			img {
				width: 68px;
				height: 58px;
			}
		}
	}
}

.leave_phone_alarm {
	margin-left: 20px;
	display: flex;
	flex-direction: column;
	.leave_phone_alarm-content {
		flex: 1;
		padding-top: 4px;
		position: relative;
	}
}
</style>
